import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Users, ClipboardCheck, BarChart3, Settings, CalendarClock } from "lucide-react";
import { motion } from "framer-motion";

const navItems = [
  { to: "/", label: "Attività", icon: ClipboardCheck, testid: "nav-attivita" },
  { to: "/atleti", label: "Elenco Atleti", icon: Users, testid: "nav-atleti" },
  { to: "/analisi", label: "Analisi Presenze", icon: BarChart3, testid: "nav-analisi" },
  { to: "/scadenze", label: "Scadenze", icon: CalendarClock, testid: "nav-scadenze" },
  { to: "/gestione", label: "Gestione", icon: Settings, testid: "nav-gestione" },
];

export default function Layout() {
  const location = useLocation();

  return (
    <div className="noise-bg min-h-screen flex flex-col lg:flex-row relative">
      {/* Sidebar */}
      <aside className="lg:w-72 lg:min-h-screen border-b lg:border-b-0 lg:border-r border-border bg-[#0b0b0b] flex lg:flex-col z-20 relative">
        <div className="p-6 border-b border-border hidden lg:block">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 bg-rugby-yellow flex items-center justify-center font-head font-bold text-black text-lg -skew-x-6">
              RCV
            </div>
            <div>
              <div className="font-head font-bold uppercase tracking-tight text-lg leading-none">
                Valpolicella
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-rugby-yellow mt-1">
                Rugby U14 · Presenze
              </div>
            </div>
          </div>
        </div>

        <nav className="flex lg:flex-col gap-1 p-3 lg:p-4 flex-1 overflow-x-auto">
          {navItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                data-testid={item.testid}
                className={({ isActive }) =>
                  `group flex items-center gap-3 px-4 py-3 whitespace-nowrap font-head uppercase tracking-wide text-sm font-medium transition-colors border-l-2 ${
                    isActive
                      ? "bg-rugby-yellow/10 text-rugby-yellow border-rugby-yellow"
                      : "text-muted-foreground border-transparent hover:text-white hover:bg-white/5"
                  }`
                }
              >
                <Icon className="h-4 w-4" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </aside>

      {/* Main content */}
      <main className="flex-1 relative z-10 min-w-0">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="p-5 sm:p-8 lg:p-12 max-w-[1400px] mx-auto"
        >
          <Outlet />
        </motion.div>
      </main>
    </div>
  );
}
